export default __webpack_public_path__ + "static/media/uploadImage.ab1be9cd.svg";